import React from 'react';
import {
  Box,
  Typography,
  IconButton,
  Slide,
  Paper,
  Link as MuiLink,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useBanners } from '~/src/entities/banners/hooks';
import {
  getIconForSeverity,
  getStylesForSeverity,
} from '~/src/theme/bannerStyles';

export const BannersDisplay = () => {
  const { data: banners = [], dismissBanner } = useBanners();
  if (banners.length === 0) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        right: 0,
        zIndex: 1337,
        p: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: 2,
        maxWidth: '100%',
      }}
    >
      {banners.map((banner) => {
        const { backgroundColor, borderTop } = getStylesForSeverity(
          banner.severity,
        );
        const icon = getIconForSeverity(banner.severity);

        return (
          <Slide key={banner.id} direction="left" in mountOnEnter unmountOnExit>
            <Paper
              elevation={4}
              sx={{
                width: 500,
                maxWidth: '90vw',
                padding: 1,
                display: 'flex',
                flexDirection: 'column',
                backgroundColor,
                borderTop,
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  width: '100%',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    flexShrink: 0,
                    mr: 1,
                  }}
                >
                  {icon}
                </Box>

                <Box
                  sx={{
                    flexGrow: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    mr: 0.5,
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: '0.75rem',
                      whiteSpace: 'pre-wrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {banner.content}
                  </Typography>

                  {banner.link && (
                    <MuiLink
                      href={banner.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      underline="hover"
                      sx={{
                        marginTop: 1,
                        fontSize: '0.75rem',
                        alignSelf: 'flex-start',
                      }}
                    >
                      More information
                    </MuiLink>
                  )}
                </Box>

                <Box
                  sx={{
                    flexShrink: 0,
                    ml: 'auto',
                  }}
                >
                  <IconButton
                    size="small"
                    onClick={() => dismissBanner(banner)}
                    sx={{
                      padding: 0.5,
                    }}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </Box>
              </Box>
            </Paper>
          </Slide>
        );
      })}
    </Box>
  );
};
